/**
 * Session persistence: the TokenPair (+ user) returned by
 * /auth/login | /registration | /auth/refresh, kept in localStorage so a
 * reload keeps the user signed in.
 *
 * Trade-off, stated plainly: localStorage is readable by any script that
 * gets XSS into the page. The scaffold accepts that (standard for SPA + JWT
 * backends without a cookie session endpoint); tightening to httpOnly
 * cookies requires backend changes and is out of scope here.
 */
const KEY = 'cap.session';

export function readSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(KEY);
}
